module.exports = __webpack_public_path__ + "static/media/selec-nft-1.feaff0af.png";